/* tslint:disable */
export const noop = (): any => {
  console.log('noop');
};
